module.exports = __webpack_public_path__ + "img/insurance-needs.609595a9.svg";